import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { FaChevronDown } from 'react-icons/fa'
import { MdOutlineTimer } from 'react-icons/md'
import { RecordTimeType } from './types'

type DropdownProps = {
  title?: string,
  menus?: RecordTimeType[],
  disabled?: boolean,
  classNameBtn?: string,
  onMenuSelected: (menu: string) => void
}

const DropdownMenu = ({
  title = 'เริ่มบันทึก',
  menus = [],
  classNameBtn = 'inline-flex justify-center w-full px-2 py-1.5 text-sm text-white disabled:text-blue-500 disabled:text-opacity-60 duration-300 bg-blue-500 disabled:bg-white rounded hover:bg-blue-600 disabled:border disabled:border-blue-500',
  disabled = false,
  onMenuSelected
} : DropdownProps) => (
  <Menu as="div" className="relative inline-block text-left">
    <div>
      <Menu.Button className={classNameBtn}
        disabled={disabled}>
        <MdOutlineTimer className="w-4 h-4 mt-0.5 mr-2"/>
        {title}
        <FaChevronDown className="w-4 h-4 mt-0.5 ml-2 -mr-1"/>
      </Menu.Button>
    </div>
    <Transition
      as={Fragment}
      enter="transition ease-out duration-100"
      enterFrom="transform opacity-0 scale-95"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
    >
      <Menu.Items className="absolute right-0 z-50 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg w-36 ring-1 ring-black ring-opacity-5 focus:outline-none">
        <div className="px-1 py-1">
          {menus.map(menu => (
            <Menu.Item key={menu.timeType} disabled={!menu.active} >
              {({ active, disabled }) => (
                <button
                  className={`${
                    active ? 'bg-gray-500 text-white' : 'text-gray-900'
                  } group flex rounded-md items-center w-full px-2 py-2 text-sm${disabled ? ' opacity-40': ''}`}
                  onClick={() => onMenuSelected(menu.timeType)}
                >
                  {menu.timeType}
                </button>
              )}
            </Menu.Item>
          ))}
        </div>
      </Menu.Items>
    </Transition>
  </Menu>
)

export default DropdownMenu